export const HYPHENATED_LANGUAGES: string[] = ['de'];
